import { ButtonHTMLAttributes, DetailedHTMLProps, MouseEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LoaderDots } from '../LoaderDots';
interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    children?: ReactNode;
    classNames?: string;
    iconbtn?: boolean;
    isLoading?: boolean;
    variant?: string;
}

export const Button = ({
    children,
    classNames = '',
    disabled,
    iconbtn,
    isLoading,
    variant,
    'aria-label': ariaLabel,
    'aria-disabled': ariaDisabled,
    onClick,
    ...props
}: ButtonProps) => {
    const { t } = useTranslation();
    const isDisabled = disabled || isLoading;
    const isAriaDisabled = ariaDisabled ?? isDisabled;

    // aria-disabled doesn't block keyboard events (Enter/Space), so we intercept here.
    const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        if (isAriaDisabled) {
            e.preventDefault();
            return;
        }
        onClick?.(e);
    };

    return (
        <button
            // @ts-ignore
            className={`btn ${iconbtn ? 'btn--icon' : ''} ${variant == 'primary' ? 'btn--primary' : ''} ${variant == 'primary-outline' ? 'btn--outline-primary' : ''} ${variant == 'white-outline-transparent' ? 'btn--outline-white' : ''} ${variant == 'secondary' ? 'btn--secondary' : ''} ${variant == 'secondary-outline' ? 'btn--outline-secondary' : ''} ${variant == 'success' ? 'btn--success' : ''} ${variant == 'success-outline' ? 'btn--outline-success' : ''} ${variant == 'warning' ? 'btn--warning' : ''} ${variant == 'warning-outline' ? 'btn--outline-warning' : ''} ${variant == 'link' ? 'btn--link' : ''} ${isDisabled ? 'btn--disabled' : ''} ${classNames}`}
            {...props}
            disabled={isDisabled}
            aria-disabled={isAriaDisabled}
            aria-label={isLoading ? t('Generic.Button.AriaLabel.isLoading') : (ariaLabel ?? '')}
            onClick={handleClick}
        >
            {isLoading ? (
                <>
                    <span className="inline-flex items-center opacity-5">{children}</span>
                    <LoaderDots classNames="absolute w-7 h-6 m-auto fill-current" />
                </>
            ) : (
                <>{children}</>
            )}
        </button>
    );
};
